<wiz-group  width="100%" height="100%" class="section-container">
  <wiz-vgroup padding="10px" width="100%" height="100%">
    <multi-display #multiDisp width="100%" height="100%" [config]="multiDisplayConfig">
      <wiz-vgroup target="title">
        <wiz-label
        [wizLabel]="'$.scen.choose.$'"
        width="100%"
        class="titleLabel"
        ></wiz-label>
      </wiz-vgroup>
    </multi-display>
    
    <wiz-hgroup width="100%" gap="20" horizontalAlign="end">
      <!-- <wiz-button wizLabel="$.scenario.add.$" [wizIcon]="'add'" (wizClick)="doAct('create')" width="150px"></wiz-button> -->
      <wiz-button *ngIf="showNullScen" wizLabel="$.scenario.null.$" 
      [wizIcon]="'cancel'" (wizClick)="doAct('cancel')" width="150px"></wiz-button>
      <wiz-button wizLabel="$.common.validate.$" (wizClick)="save()" [wizDisabled]="!validable" width="150px"></wiz-button>
    </wiz-hgroup>

  </wiz-vgroup>
  
  <wiz-hgroup padding="10px" width="100%" horizontalAlign="end">
    <wiz-icon (click)="hide()" style="cursor: pointer">close</wiz-icon>
  </wiz-hgroup>
  

</wiz-group>
